<template>
<div class="container">
    <!-- <Breadcrumb class="bread_block" /> -->
    <CommonBreadcrumb class="bread_block" />
    <div class="row">
        <div class="col-lg-3 col-md-4">
            <CustomerServicePolicyMenu />
        </div>

        <div class="col-lg-9 col-md-8">
            <CustomerServiceShippingPolicyIndia v-if="$country.is_india"/>
            <CustomerServiceShippingPolicyUs  v-else/>

            <CustomerServicePolicyContactIndia v-if="$country.is_india" />
            <CustomerServicePolicyContact  v-else />
        </div>
    </div>
</div>
</template>

<script setup>
    const { $country } = useNuxtApp()
    // const meta = useHeadManager()
    // console.log(meta, 'metatatatat')
    // useHead(meta)
    useFetchMeta( useNuxtApp(), useRuntimeConfig() );
</script>


<style scoped>
@media(min-width:1024px) and (max-width: 1550px){
    .container{
        max-width: 992px;
    }
}
</style>